import { create } from 'zustand';

type ChatResponseCompletionStatusStore = {
  completionStatusByAttemptAuditId: Record<string, boolean>;
  setCompletionStatusForAttemptAuditId: (attemptAuditId: string, isCompleted: boolean) => void;
};

export const useChatResponseCompletionStatusStore = create<ChatResponseCompletionStatusStore>(
  set => ({
    // maps attempt audit id to completion status
    completionStatusByAttemptAuditId: {},
    setCompletionStatusForAttemptAuditId: (attemptAuditId: string, isCompleted: boolean) => {
      set(state => ({
        completionStatusByAttemptAuditId: {
          ...state.completionStatusByAttemptAuditId,
          [attemptAuditId]: isCompleted,
        },
      }));
    },
  }),
);
